// src/components/SignUp.vue
<template>
<div class="col-md-5 ml-auto mr-auto" style="margin-top: 100px">
  <card class="card-signup" header-classes="text-center" color="orange">

    <h3 class="card-title title-up">{{ formState === 'signUp' ? 'SIGN UP' : 'CONFIRM SIGN UP' }}</h3>
    <div class='formcontainer' v-if="formState === 'signUp'">

      <fg-input
        class="no-border input-lg"
        addon-left-icon="now-ui-icons users_circle-08"
        placeholder="E-Mail"
        v-model='form.email'
        v-on:keyup="inputChanged"
      >
      </fg-input>

      <fg-input
        class="no-border input-lg"
        addon-left-icon="now-ui-icons text_caps-small"
        placeholder="Password"
        type='password'
        v-model='form.password'
        v-on:keyup="inputChanged"
      >
      </fg-input>

      <fg-input
        class="no-border input-lg"
        addon-left-icon="now-ui-icons text_caps-small"
        placeholder="Confirm new password"
        type='password'
        v-model='password_confirmation'
        v-on:keyup="inputChanged"
      >
      </fg-input>
      <div id="infoArea">{{info_text}}</div>
      <div class="card-footer text-center">
        <n-button v-on:click='signUp' type="neutral" round size="lg">Sign up</n-button>
      </div>


    <!--
      <input v-model='form.email' class='input' placeholder="E-Mail"/>
      <input type='password' v-model='form.password' class='input' placeholder="Password"/>
      <button v-on:click='signUp' class='button'>Sign Up</button>
    -->


    </div>
    <div class='formcontainer' v-if="formState === 'confirmSignUp'">

      <fg-input
        class="no-border input-lg"
        addon-left-icon="now-ui-icons text_caps-small"
        placeholder="Authentication Code"
        v-model='form.authCode'
        v-on:keyup="validationInputChanged"
      >
      </fg-input>
      <!--
      <div v-bind:class="amplifyUI.hint">
        {{$Amplify.I18n.get('Lost your code? ')}}
        <a v-bind:class="amplifyUI.a" v-on:click="resend" v-bind:data-test="auth.signUp.resendCodeLink">{{$Amplify.I18n.get('Resend Code')}}</a>
      </div>
      -->





      <div>{{validation_info_text}}</div>

      <div style="padding-top:20px">
        {{$Amplify.I18n.get('Lost your code? ')}}
        <span class="txt" v-on:click="resend">{{$Amplify.I18n.get('Resend Code')}}</span>
      </div>

      <div class="card-footer text-center">
        <n-button v-on:click='confirmSignUp' type="neutral" round size="lg">Confirm Sign Up</n-button>
      </div>

    </div>

    <div class='formcontainer' v-if="formState === 'confirmAuthCode'">

      <div>Registration was successful, and you can now sign in to your account</div>
      <div class="card-footer text-center">
        <n-button v-on:click='signIn' type="neutral" round size="lg">Sign in</n-button>
      </div>


    </div>



    </card>
</div>


</template>

<script>
import { Auth } from 'aws-amplify'
import { AmplifyEventBus } from 'aws-amplify-vue'
import * as AmplifyUI from '@aws-amplify/ui';
import Vue from 'vue';
import { Card, Button, FormGroupInput } from '@/components';
export default {
  name: 'home',
  props: ['toggle'],
  components: {
    Card,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput
  },
  data() {
    return {
      formState: 'signUp',
      form: {
        username: '',
        password: '',
        email: ''
      },
      password_confirmation: '',
      info_text: '',
      validation_info_text: 'We have send you a confirmation code to your email address. Please enter this code here.'
    }
  },
  methods: {
    async signUp() {
      if (this.form.password!=this.password_confirmation){
        this.info_text = "Password does not match the password confirmation field. Please try again."
      }else{
        let user = {
          attributes: {},
        };
        user.username = this.form.email;
        user.password = this.form.password;
        const { username, password, email } = this.form
        await Auth.signUp(user)
          .then(data => console.log("user signed up"))
          .then(()=>this.formState = 'confirmSignUp') // switches Sign Up to Verification
          .catch(err => {
            this.info_text = this.$Amplify.I18n.get(err.message || err)
          })
      }



    },
    async confirmSignUp() {
      const { username, authCode } = this.form
      await Auth.confirmSignUp(this.form.email, authCode)
        .then(()=>{
          this.formState = 'confirmAuthCode';
        })
        .catch(err => {
          this.validation_info_text = this.$Amplify.I18n.get(err.message || err)
        })

    },

    inputChanged: function (event) {
      this.info_text = '';
    },
    validationInputChanged: function (event) {
      this.validation_info_text = '';
    },
    resend() {
        this.$Amplify.Auth.resendSignUp(this.form.email)
            .then(() => {
              this.logger.info('resendSignUp success')
              this.info_text = "New Code was sent to your mail address"
            })
            .catch(e => this.info_text = this.$Amplify.I18n.get(e.message || e));
    },
    signIn: function (event) {
      AmplifyEventBus.$emit('authState', 'signIn');
    },


  }
}
</script>
<style>
.txt:hover {
    text-decoration: underline;
}
</style>
